// @flow

import React from "react";
import { Pagination as AntdPagination } from "antd";
import { useEffect } from "react";
import { useState } from "react";

import { getItemsForPage } from "../../utils/arrays";

import styled from "styled-components/macro";

const Container = styled.div`
  .pagination {
    margin-top: 24px;
    text-align: center;
  }
`;

const Pagination = ({ pageSize = 10, data = [], children, style }) => {
  const [page, setPage] = useState(1);
  useEffect(() => {
    if (data.length < page) setPage(1);
  }, [data, page]);

  return (
    <Container data-test="pagination" style={style}>
      {children &&
        children({
          data: getItemsForPage(data, page, pageSize)
        })}
      <AntdPagination
        hideOnSinglePage
        className="pagination"
        pageSize={pageSize}
        current={page}
        onChange={page => setPage(page)}
        total={data.length}
      />
    </Container>
  );
};

export default Pagination;
